<template>
    <el-drawer
        title="搜索并绑定 POIID"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="800px"
        @close="close"
        append-to-body
    >
        <div class="drawer-content" v-loading="dataLoading">
			<div class="MB20">				 
				<p v-if="dataSite">场地名称: {{dataSite.name}} <span class="ML50">地址:{{dataSite.address}}</span></p>
			</div>
            <div class="page-filter-box">
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-input v-model="keyword" size="small" placeholder="关键词"></el-input>
                    </el-col>
                    <el-col :span="8">
                        <el-cascader
                            v-model="areaCode"
                            :options="cityList"
                            filterable
                            :props="{label:'name',children:'cityList',value:'id'}"
                            size="small"
                            style="width:100%"
                            ref="cityCascader"
                            placeholder="选择省份/城市"                           
                            clearable>
                        </el-cascader>
                    </el-col>                   
                    <el-col :span="8" class="page-filter-btns">
                        <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                        <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                    </el-col>
                </el-row>
            </div>
			<div class="page-list-box">
			    <el-table
			        :data="dataList"
			        border
			        style="width: 100%"
			        v-loading="listLoading"
			        size="small"			        
					highlight-current-row					
			    >			        	        
			        <el-table-column prop="poiId" label="POI ID"></el-table-column>
			        <el-table-column prop="name" label="POI名称" min-width="120" show-overflow-tooltip></el-table-column>			       
			        <el-table-column prop="address" label="地址" ></el-table-column>
			        <el-table-column prop="categoryName" label="POI分类"></el-table-column>
					<el-table-column fixed="right" label="操作">
						<template slot-scope="scope">
						    <el-button
						        v-if="$utils.have('/site/savePoiId')"
						        type="text"
						        size="small"
						        icon="el-icon-view"
						        @click="bind(scope.row.poiId)"
						        >绑定POIID</el-button>
						</template>
					</el-table-column>	
			    </el-table>
			</div>
        </div>
    </el-drawer>
</template>

<script>
import {fetchAllCity} from '@/assets/js/commonApi'

export default {
    props:{
        userId:{
            type:[Number,String],
            default:''
        },
		data: {
		    type: Object,
		    default: ()=> {}
		}
    },
    components:{},
    data(){
        return{
            drawerShow: false,
            dataLoading: false,
            btnLoading:false,
			listLoading:false,
            id:'',
			
			dataSite: null,
			dataList: null,
			cityList: [],
			areaCode: [],
			keyword:'',
			city:[],
			cityName:'',
			currentRow: null
        }
    },
  
    methods:{      
        close() {           
			this.drawerShow = false;
			this.areaCode = [];
			this.dataList = null;
			this.keyword = ''
        },
        show() {
            this.id = this.userId;           
            this.drawerShow = true;			
			this.dataSite = this.data
			this.areaCode = [parseInt(this.dataSite.provinceCode),parseInt(this.dataSite.cityCode)]			
			this.keyword = this.dataSite.name
			this.getCityList()
			
        },
		//获取所有城市
		async getCityList(){
		    const res = await fetchAllCity({}).catch(() => {});
		    const{ state, result} = res.data;
		    if( state == 1 ){
		        this.cityList = result;
		    }
            this.$nextTick(() => {
                this.getDataList()
            })
		},
		
		bind(id){
			console.log(this.id)
			console.log(this.userId)
			const _url = "/site/savePoiId";
			this.btnLoading = true;
			this.$request({
			    url: _url,
			    params: {
			        id:this.id,
					poiId:id
			    },
			    method: "post",
			})
			    .then((res) => {
			        const { state, msg } = res.data;
			        if (state == 1) {
			            this.$message.success("操作成功");
			            this.close();
						this.$emit('onUpdate');
			        } else {
			            this.$message.error(msg || "操作失败,请重试");
			        }
			    })
			    .catch(() => {
			        this.$message.error("操作失败,请重试");
			    })
			    .finally(() => {
			        this.btnLoading = false;
			    });  
		},
		//获取城市
		async getCityName(){
		    const _nodes = this.$refs.cityCascader.getCheckedNodes()
            console.log(_nodes)
            if (_nodes && _nodes.length > 0) {
                const _node = _nodes[_nodes.length - 1]
                this.cityName = _node.label
            } else {
                this.cityName = ''
            }
		    
		},
        //获取列表
        getDataList() {
			this.getCityName()
			if( this.keyword == ''){
				return  this.$message.error("先请输入关键词");
			}
            this.listLoading = true;
            this.$request({
                url: "/site/searchPoi",
                method: "POST",
                params: {
                    cityName:this.cityName,
					keyword:this.keyword,
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                       
                        this.dataList = result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //搜索
        search() {            
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.show()
        },
        submitAction(){			
			const _url = "/site/savePoiId";
            this.btnLoading = true;
            this.$request({
                url: _url,
                params: {
                    id:this.id,
					poiId:this.formData.poiId
                },
                method: "post",
            })
                .then((res) => {
                    const { state, msg } = res.data;
                    if (state == 1) {
                        this.$message.success("操作成功");
                        this.close();
						this.$emit('onUpdate');
                    } else {
                        this.$message.error(msg || "操作失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("操作失败,请重试");
                })
                .finally(() => {
                    this.btnLoading = false;
                });   
        }
    }
}
</script>

<style lang="scss" scoped>
.ML50{
	margin-left: 50px;
}
.preview-box{
    text-align: center;
    .el-image{
        max-width: 100%;
    }
}
.upload-btn {
    height: 36px;
    line-height: 36px;
    border-radius: 4px;
    text-align: center;
    position: relative;
    background: $--color-theme;
    overflow: hidden;
    .upload-bar{
        ::v-deep .el-upload{
            width: 100%;
        }
    }
    .el-button {
        width: 100%;
        background: none;
        border: 0;
    }
    .progress-bar {
        display: block;
        height: 100%;
        color: #ffffff;
        span {
            position: absolute;
            height: 100%;
            width: 100%;
            left: 0;
            top: 0;
        }
        .progress {
            height: 100%;
            background: #67c23a;
            transition: width 0.6s ease-out;
        }
    }
}

</style>